import { render, staticRenderFns } from "./ItemListOrdineMTM.vue?vue&type=template&id=630601cd"
import script from "./ItemListOrdineMTM.vue?vue&type=script&lang=ts"
export * from "./ItemListOrdineMTM.vue?vue&type=script&lang=ts"
import style0 from "./ItemListOrdineMTM.vue?vue&type=style&index=0&id=630601cd&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630601cd')) {
      api.createRecord('630601cd', component.options)
    } else {
      api.reload('630601cd', component.options)
    }
    module.hot.accept("./ItemListOrdineMTM.vue?vue&type=template&id=630601cd", function () {
      api.rerender('630601cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtm/ItemListOrdineMTM.vue"
export default component.exports